import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Radio } from '@startuptools/ui/Radio';
import { RadioGroup } from '@startuptools/ui/RadioGroup';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { GqlMeeting, useSetMeetingLanguageMutation } from '../../../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Controller, type SubmitHandler, useForm } from 'react-hook-form';
import { useStepper } from '../../../../components/steppers/common/StepperContext';

type FormValues = { biLingual: 'true' | 'false' };

export const MeetingStepLanguages = ({ meeting }: { meeting: Pick<GqlMeeting, 'id' | 'secondaryLang'> }) => {
  const companyId = useCompanyId();
  const { stepNext } = useStepper();
  // eslint-disable-next-line sut/loading-mutation
  const [doSetLanguage] = useSetMeetingLanguageMutation();

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: { biLingual: meeting.secondaryLang ? 'true' : 'false' },
  });

  const onSubmit: SubmitHandler<FormValues> = async input => {
    await doSetLanguage({
      variables: { companyId, input: { id: meeting.id, primaryLang: true, secondaryLang: input.biLingual === 'true' } },
    });
    return stepNext();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack gap={3}>
        <Typography level="h4">
          <Trans id="Language of the Meeting" />
        </Typography>
        <Controller
          control={control}
          name="biLingual"
          render={({ field }) => (
            <RadioGroup {...field}>
              <Radio value={false} label={<Trans id="Only in Swedish" />} required />
              <Radio value label={<Trans id="Swedish and English" />} required />
            </RadioGroup>
          )}
        />

        <Box>
          <Button type="submit">
            <Trans id="Save and Continue" />
          </Button>
        </Box>
      </Stack>
    </form>
  );
};
